import { endOfWeek, isAfter, isBefore, startOfDay, startOfWeek } from 'date-fns';
import { useCallback } from 'react';
import { getDateType } from '../../base-picker';
import type { CalendarDateType } from '../types';

type P = {
  current: CalendarDateType;
  value: Date;
};

export const useGetWeekSelectionModeValues = () =>
  useCallback(({ current, value }: P) => {
    const start = startOfDay(startOfWeek(value));
    const end = startOfDay(endOfWeek(value));

    const currentDate = getDateType(current);
    const currentDay = startOfDay(currentDate);

    return {
      isInWeek: !isBefore(currentDay, start) && !isAfter(currentDay, end),
    };
  }, []);
